
export { default as ClockDashedIcon } from "./ClockDashed.js"